export const testAttributes = {
    INLINE_SOURCE_LINK: 'inline-source-link',
    INLINE_SOURCE_LINK_TOOLTIP: 'inline-source-link-tooltip',
    INLINE_SOURCE_LINK_BUTTON: 'inline-source-link-button',
};
